import { useContext } from 'react';

import { Field, Image, ImageField, Link, LinkField, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { WildCardRouteContext } from 'src/context/WildCardRoute/WildCardRouteContext';

import { ComponentProps } from 'lib/ComponentProps';

import { isRcniCPDArticle, isRcniLearningModule, isResourcePage } from 'src/utils/isTemplate';

import styles from './ContentOverviewPortfolioCallToAction.module.css';

type CallToActionFields = {
	title?: Field<string>;
	subtitle?: Field<string>;
	image?: ImageField;
};

type PortfolioCallToActionProps = ComponentProps & {
	fields: {
		HidePortfolioCallToAction: Field<boolean>;
		Url: LinkField;
		RCNResourceTitle: Field<string>;
		RCNResourceSubtitle: Field<string>;
		RCNResourceImage: ImageField;
		RCNiCPDArticleTitle: Field<string>;
		RCNiCPDArticleSubtitle: Field<string>;
		RCNiCPDArticleImage: ImageField;
		RCNiLearningModuleTitle: Field<string>;
		RCNiLearningModuleSubtitle: Field<string>;
		RCNiLearningModuleImage: ImageField;
	};
};

export default withDatasourceCheck()<PortfolioCallToActionProps>(ContentOverviewPortfolioCallToAction);

function ContentOverviewPortfolioCallToAction(props: PortfolioCallToActionProps): JSX.Element {
	const WildCardItemInfo = useContext(WildCardRouteContext);

	if (props.fields?.HidePortfolioCallToAction?.value) {
		return <></>;
	}

	const ctaFields: CallToActionFields = {};
	let { title, subtitle, image } = ctaFields;

	if (isResourcePage(WildCardItemInfo?.wildCardItemInfo?.TemplateId)) {
		title = props.fields.RCNResourceTitle;
		subtitle = props.fields.RCNResourceSubtitle;
		image = props.fields.RCNResourceImage;
	} else if (isRcniCPDArticle(WildCardItemInfo?.wildCardItemInfo?.TemplateId)) {
		title = props.fields.RCNiCPDArticleTitle;
		subtitle = props.fields.RCNiCPDArticleSubtitle;
		image = props.fields.RCNiCPDArticleImage;
	} else if (isRcniLearningModule(WildCardItemInfo?.wildCardItemInfo?.TemplateId)) {
		title = props.fields.RCNiLearningModuleTitle;
		subtitle = props.fields.RCNiLearningModuleSubtitle;
		image = props.fields.RCNiLearningModuleImage;
	} else {
		return <></>;
	}

	return (
		<section className="maxWidth maxHeight">
			<Link
				field={props.fields.Url}
				title="Portfolio Card"
				className={`maxWidth padX noExternalSiteIcon ${styles.portfolioCallToActionContainer}`}
			>
				<div className={styles.infoContainer}>
					<Text tag="h3" field={title} className={styles.resourceTitle} />

					<Text tag="p" field={subtitle} className={styles.resourceSubTitle} />
				</div>
				<div className={styles.imageContainer}>
					<Image field={image} className={styles.image} />
				</div>
			</Link>
		</section>
	);
}
